import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  LOCALE_ID,
  Inject,
  Input,
  OnChanges,
  SimpleChange,
  Output,
  EventEmitter,
  OnDestroy,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";

import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import {
  tap,
  debounceTime,
  distinctUntilChanged,
  take,
  mergeMap,
  shareReplay,
} from "rxjs/operators";
import { merge, fromEvent, of, EMPTY, Observable, Subscription } from "rxjs";
import { ModelsDataSource } from "src/app/services/model.datasource";

import {
  displayValue,
  getFilterValue,
  getQueryFilters,
} from "src/app/helpers/utils";
import { SelectionModel } from "@angular/cdk/collections";
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from "@angular/material/table";

import { AbstractControl } from "@angular/forms";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { MatDialog } from "@angular/material/dialog";

import { environment } from "src/environments/environment";
import { UserContextService } from "src/app/services/user-context.service";
import { HttpClient } from "@angular/common/http";
import { QueryParameter } from "../helpers/queryParameter";
import { QueryFilter } from "../helpers/queryFilter";
import { ApiService } from "../services/api.service";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from "@angular/material/expansion";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatIcon } from "@angular/material/icon";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { MatFormField } from "@angular/material/form-field";
import { NgStyle, NgTemplateOutlet, AsyncPipe } from "@angular/common";

const BASE_API = environment.apiUrl;
@Component({
    selector: "agil-mat-table-list",
    templateUrl: "./mat-table-list.component.html",
    styleUrls: ["./mat-table-list.component.scss"],
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ],
    standalone: true,
    imports: [
    MatFormField,
    MatInput,
    NgStyle,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    MatFooterCellDef,
    MatFooterCell,
    MatSortHeader,
    MatButton,
    MatCheckbox,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    NgTemplateOutlet,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    MatPaginator,
    MatProgressSpinner,
    AsyncPipe
],
})
export class MatTableListComponent
  implements AfterViewInit, OnInit, OnChanges, OnDestroy
{
  expandedElement: any | null;
  instances: ModelsDataSource;
  title: string;
  displayedColumnNames: string[];
  displayedColumns: any;
  tableHeaders = [];
  /** Question pratique pour utilisation dans le template  */
  templateColsName: Map<number, string[]> = new Map();
  query: QueryParameter;
  pageSize = 10;
  BASE_IMAGES = environment.webRootApi;
  selection: SelectionModel<any>;
  /** Emet les éléments selectionnés au model list component */
  @Output() selectionEmitter = new EventEmitter<any>();
  selectionEmitter$: Subscription;
  /** master/detail: models enfants à charger */
  childrenModels: Map<string, Observable<any>> = new Map();
  /** master/detail: row parent */
  @Input() parentRow: any;
  /** <SequenceValue, boolean> master/detail: liste des enfants chargés. Utilisé pour les charger à la demande  */
  childrenLoaded: Map<string, boolean> = new Map();
  buttonActions: any;
  @Input() allowMultiSelect = false;
  @Input() modelDefinition: any;
  @Input() hideOpenButton: boolean;
  /** existe déjà dans le model définition mais on peut ne vouloir l'appliquer QUE sur le home. Dans ce cas on le met à true dans le json du tableau du home */
  @Input() hideTableWinPropButton: boolean;
  @Input() inputValue: string;
  @Input() queryFilters: QueryFilter[];
  /** Dans le cas d'un master/detail. Si le table est un detail, masterQueryFilters sont les query filters du Master.
   * Transmis à l'Api seulement si sendMasterQueryFilters = true sur le child. Cf model ApproPlanning
   */
  @Input() masterQueryFilters: QueryFilter[];
  @Input() inputPageSize: number;
  @Input() parentType: string;
  /** On cache les boutons actions (ex: Passer en Bl) si on affiche par exemple la dernière recherche*/
  @Input() hideButtonActions: boolean;
  // Control parent si le tableau est appelé par un assistant
  @Input() parentControl: AbstractControl;
  /** Sequence courante si le tableau ets appelé depuis la dernière recherche */
  @Input() currentSequence: number;
  /** true si le tableau est appelé par l'assistant de saisie */
  @Input() isAssistant: boolean;
  @Input() refresh: boolean;
  @Input() modelListSequences: any;
  @Input() origin: string;
  /** Sélectionne la ligne on enter */
  @Input() toggleOnEnter = true;
  hover: boolean[] = [];
  console = console;
  sortChange$: Subscription;
  sortOrPageChange$: Subscription;
  inputChange$: Subscription;
  selectedValues$: Subscription;
  autoToggleFirstOne$: Subscription;
  /** Dans le cas d'une mono-selection (assistants...) on laisse la sélection manuelle de la check box select faire son travail à la place de la directive MatRowKeyboardSelection */
  isHoverSelect = false;
  constructor(
    private router: Router,
    private apiService: ApiService,
    public dialog: MatDialog,
    public userContext: UserContextService,
    private http: HttpClient,
    private renderer: Renderer2,
    @Inject(LOCALE_ID) protected localeId: string
  ) {}
  ngOnDestroy(): void {
    this.selectionEmitter$?.unsubscribe();
    this.sortChange$?.unsubscribe();
    this.sortOrPageChange$?.unsubscribe();
    this.inputChange$?.unsubscribe();
    this.selectedValues$?.unsubscribe();
  }

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild("input", { static: false }) input: ElementRef;
  @ViewChild("assistTable", { static: false }) table: MatTable<any>;

  ngOnChanges(changes: { [propKey: string]: SimpleChange }): void {
    if (changes.refresh?.currentValue) {
      this.loadPage();
    } else if (
      !changes.queryFilters?.firstChange &&
      changes.queryFilters?.currentValue !== undefined
    ) {
      this.query.queryFilters = changes.queryFilters.currentValue;
      this.paginator.pageIndex = 0;
      this.loadPage(false, true);
    }
  }

  /** charge les modelDefinition des children */
  loadChildrenModels() {
    this.modelDefinition.children?.forEach((child) => {
      if (child.model !== undefined) {
        const model$ = child.isQuery
          ? this.http.get(
              `${BASE_API}/config/queryModel/${child.model}/${child.queryName}`
            )
          : this.apiService.getModel(child.model);

        const obs = model$.pipe(
          take(1),
          mergeMap((res: any) => {
            if (res) {
              if (child.isQuery) {
                const rows = res.properties.find(
                  (prop) => prop.name === "Rows"
                );
                // this.apiService.replaceModel(rows);
                return of(rows);
              } else if (child.dynamicModel) {
                //this.apiService.replaceModel(res);
                return of(res);
              } else {
                // this.apiService.InsertModel(res);
                return of({ ...res });
              }
            } else {
              return EMPTY;
            }
          }),
          shareReplay({ bufferSize: 1, refCount: true })
        );
        this.childrenModels.set(child.name, obs);
      }
    });
  }
  ngOnInit() {
    if (this.modelDefinition.name !== undefined) {
      /** Note, this.modelDefinition est cloné. Ici on récupère le model stocké dans l'apiService pour le mettre à jour */
      // const modelInState = this.apiService.getModel(
      //   this.modelDefinition.name
      // );
      const modelInState = this.modelDefinition;
      /** int des ids utilisés pour suiv/prec */
      modelInState.ids = [];
      if (this.origin !== "LAST_SEARCH") {
        /** index des enregistrements dans la liste d'origine. utilisé pour la pagination suiv/prec */
        modelInState.paginationIds = {};
      }
      this.loadChildrenModels();
      // only displayOnList sorted by order
      this.modelDefinition.properties = this.modelDefinition.properties
        .filter((p) => p.displayOnList)
        .sort(
          (obj1, obj2) =>
            (obj1.orderOnList || 99999) - (obj2.orderOnList || 99999)
        );
      // matHeaderRowDef
      this.displayedColumnNames = this.modelDefinition.properties.map(
        (p) => p.name
      );
      this.displayedColumns = this.modelDefinition.properties;

      this.buttonActions = this.modelDefinition.actions?.filter(
        (action) =>
          action.type === "button" && action.location === "tableActionBar"
      );

      this.pageSize = this.inputPageSize
        ? this.inputPageSize
        : this.modelDefinition.pageSize
        ? this.modelDefinition.pageSize
        : 10;
      if (this.modelDefinition.children?.length > 0) {
        this.displayedColumnNames.unshift("openChildren");
      }
      // if (!this.modelDefinition.list?.hideSelectCheckBox) {
      //   this.displayedColumnNames.unshift("select");

      //   this.selection = new SelectionModel<any>(this.allowMultiSelect, []);
      //   this.selectionEmitter$ = this.selection.changed
      //     .asObservable()
      //     .subscribe((select) => {
      //       this.selectionEmitter.emit(this.selection);
      //     });
      // }

      //this.displayedColumnNames.push("tableMenu");
      // headers supplémentaires
      // 1. header 'titre'
      if (this.modelDefinition.list?.header?.title) {
        this.tableHeaders.push({
          name: "title-header",
          cols: [
            {
              label: this.modelDefinition.list?.header?.title as string,
              span: this.displayedColumnNames.length,
              backgroundColor:
                this.modelDefinition.list?.header?.backgroundColor,
            },
          ],
        });
        this.templateColsName.set(0, ["col-0-header-0"]);
      }
      // 2. headers supplémentaires
      this.modelDefinition.list?.headers?.forEach((header, index) => {
        this.templateColsName.set(
          this.templateColsName.size,
          header.cols.map(
            (col, indexCol) =>
              "col-" + indexCol + "-header-" + this.templateColsName.size
          )
        );

        this.tableHeaders.push(header);
      });

      // Paginate /sort / filter server side
      // https://blog.angular-university.io/angular-material-data-table/
      this.query = new QueryParameter();
      this.query.start = 0;
      this.query.requestedItemCount = this.pageSize;
      /** Tableau des noms des propriétés à select (SQL) envoyé à l'api pour optimisation */
      if (!this.modelDefinition.dontSendQuerySelect) {
        this.query.querySelect = [...this.displayedColumnNames].filter(
          (col) =>
            col !== "select" && col !== "tableMenu" && col !== "openChildren"
        );
      }
      // Si il y a des queryFilters en sus
      if (this.queryFilters?.length) {
        this.queryFilters.forEach((queryFilter) => {
          // si le fieldName est renseigné on va chercher la valeur du controle correspondant
          if (queryFilter.fieldName !== undefined) {
            if (this.parentControl.parent?.get(queryFilter.fieldName)?.value) {
              queryFilter.Value = this.parentControl.parent?.get(
                queryFilter.fieldName
              )?.value;
            } else {
              return;
            }
          } else {
            // sinon si le fieldName n'est renseigné on prend la value telle quelle après interpolation (ex: {{userconnected}})
            queryFilter.Value = getFilterValue(queryFilter, this.userContext);
          }
          // si issu d'un master /detail
          if (queryFilter.parentFieldName !== undefined) {
            if (this.parentRow.hasOwnProperty(queryFilter.parentFieldName)) {
              queryFilter.Value = this.parentRow[queryFilter.parentFieldName];
            } else {
              return;
            }
          }
          this.query.queryFilters.push(queryFilter);
        });
        /** traitement spécial composant recherche. Si l'assistant est dans la form de recherche, on ne filtre que si TOUS ses filtres sont renseignés */
        if (this.parentType === "search") {
          this.query.queryFilters = getQueryFilters(
            this.query.queryFilters,
            this.parentType
          );
        }
      }
      // si il y a des queryFilters définis dans le modelDefinition
      if (
        this.modelDefinition.queryFilters !== undefined &&
        this.modelDefinition.queryFilters.length > 0
      ) {
        this.query.queryFilters.push(...this.modelDefinition.queryFilters);
      }
      /** Cas d'un Master / Detail */
      if (this.masterQueryFilters?.length > 0) {
        this.masterQueryFilters.forEach((f) =>
          this.query?.queryFilters?.push(f)
        );
      }

      if (this.inputValue) {
        this.query.MatTableFilter = "%" + this.inputValue + "%";
        this.query.MatTableProperties = this.displayedColumns
          .map((p) => p.name)
          .reduce((x, y) => x + y + ";", "");
      }
      this.instances = new ModelsDataSource(
        this.modelDefinition,
        this.apiService
      );
      /** Dans le cas ou le tableau est dans le ModelListComponent, il est chargé automatiquement depuis le composant search (f° search()) donc on évite de le remplir deux fois   */
      if (this.parentType !== "LIST") {
        this.instances.loadInstances(this.query, this.modelListSequences);
      }
    } else {
      this.instances = new ModelsDataSource(null, this.apiService);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.inputValue) {
        this.input.nativeElement.value = this.inputValue;
      }
    });
    this.sortChange$ = this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = 0)
    );
    if (this.input) {
      this.inputChange$ = fromEvent(this.input?.nativeElement, "keyup")
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          tap(() => {
            this.paginator.pageIndex = 0;
            this.loadPage();
          })
        )
        .subscribe();
    }
    this.sortOrPageChange$ = merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.loadPage(true)))
      .subscribe();
  }
  loadPage(bSort = false, queryFiltersHaveChanged = false) {
    this.query.start = this.paginator.pageIndex * this.paginator.pageSize;
    this.query.requestedItemCount = this.paginator.pageSize;
    this.query.MatTableFilter = null;
    this.query.MatTableProperties = null;
    /** Tableau des noms des propriétés à select (SQL) envoyé à l'api pour optimisation */
    if (!this.modelDefinition.dontSendQuerySelect) {
      this.query.querySelect = [...this.displayedColumnNames].filter(
        (col) =>
          col !== "select" && col !== "tableMenu" && col !== "openChildren"
      );
    }
    if (this.input?.nativeElement?.value) {
      this.query.MatTableFilter = "%" + this.input.nativeElement.value + "%";
      this.query.MatTableProperties = this.displayedColumns
        .map((p) => p.name)
        .reduce((x, y) => x + y + ";", "");
    }
    if (queryFiltersHaveChanged) {
      // si il y a des queryFilters définis dans le modelDefinition
      if (
        this.modelDefinition.queryFilters !== undefined &&
        this.modelDefinition.queryFilters.length > 0
      ) {
        this.query.queryFilters.push(...this.modelDefinition.queryFilters);
      }
    }
    if (bSort) {
      // Remove les sort précédents (on pourra plus tard faire du multi sort)
      this.query.queryFilters = this.query.queryFilters.filter(
        (x) => x.QueryOperator.substring(0, 4) !== "Sort"
      );
      // si il y a des queryFilters SORT définis dans le modelDefinition on les rajoute avant
      if (
        this.modelDefinition.queryFilters !== undefined &&
        this.modelDefinition.queryFilters.length > 0 &&
        this.modelDefinition.queryFilters.some(
          (x) => x.QueryOperator.substring(0, 4) === "Sort"
        )
      ) {
        this.query.queryFilters.push(
          ...this.modelDefinition.queryFilters.filter(
            (x) => x.QueryOperator.substring(0, 4) === "Sort"
          )
        );
      }
      if (this.sort.active !== undefined) {
        // Remove les sort précédents (on pourra plus tard faire du multi sort)
        // si on a plusieurs sort définis dans le modelDefinition il suffit de refaire chercher pour re-trier
        this.query.queryFilters = this.query.queryFilters.filter(
          (x) => x.QueryOperator.substring(0, 4) !== "Sort"
        );
        const sortOperator =
          "Sort" +
          this.sort.direction.charAt(0).toUpperCase() +
          this.sort.direction.slice(1);

        const f = new QueryFilter();
        f.Name = this.sort.active;
        f.QueryOperator = sortOperator === "Sort" ? "SortAsc" : sortOperator;
        this.query.queryFilters.push(f);
      }
    }
    //this.updateChildrenModelsWithQueryParameter();
    this.instances.loadInstances(this.query, this.modelListSequences);
  }
  display(column, value) {
    return displayValue(column, value, this.localeId);
  }

  manageExpandedRow(row) {
    this.modelDefinition.children?.forEach((child) => {
      if (!child.accordion) {
        this.childrenLoaded.set(child.name + row.SequenceValue, true);
      }
    });
    return row;
  }
    /**
   * if hyperLinkToDetail || hyperLink ...
   * @param instance
   * @param column
   * @param link
   * @returns
   */
     clickToLink(rowInstance, column: any, link, rowIndex) {}
     getImage(value: any) {
      const image = value ? value : undefined;
      return !image
        ? image
        : image.substring(0, 4) === "http"
        ? image
        : this.BASE_IMAGES + image;
    }
      /** Si on click sur une cellule du tableau de typeInList = 'button' */
  buttonClick(clickParams, row) {}
  
}
